const vars = {
    port:   process.env.REACT_APP_PORT,
    apiUrl: process.env.REACT_APP_API_URL,
};

export default vars;